import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';



const SimuladorIncentivosTecnicoServicio = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
    });

    const [incentivo, setIncentivo] = useState({
        nivel: "",
        horas: 0,
        incentivo: 0,
        bono: 0,
        incentivoTotal: 0
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setIncentivo((prev) => ({
            ...prev,
            [name]: name === "horas" ? Number(value) : value,
        }));
    };

    const rangoServicio = [
        { minimo: 0, maximo: 50, monto: 50 },
        { minimo: 50, maximo: 100, monto: 65 },
        { minimo: 100, maximo: 140, monto: 85 },
        { minimo: 140, maximo: 150000, monto: 95 },
    ]

    const rangoAvanzado = [
        { minimo: 0, maximo: 50, monto: 50 },
        { minimo: 50, maximo: 100, monto: 55 },
        { minimo: 100, maximo: 140, monto: 105 },
        { minimo: 140, maximo: 150000, monto: 110 },
    ]

    const rangoMaster = [
        { minimo: 0, maximo: 50, monto: 85 },
        { minimo: 50, maximo: 100, monto: 105 },
        { minimo: 100, maximo: 140, monto: 115 },
        { minimo: 140, maximo: 150000, monto: 145 },
    ]

    useEffect(() => {
        if (incentivo.horas > 0 && incentivo.nivel !== "") {
            const horasTotales = incentivo.horas;
            let bono = incentivo.bono || 0;
            const nivel = incentivo.nivel;

            const rango = nivel === "M" ? rangoMaster
                : nivel === "A" ? rangoAvanzado
                    : rangoServicio;

            let horasRestantes = horasTotales;
            let totalIncentivo = 0;

            for (let i = 0; i < rango.length; i++) {
                const { minimo, maximo, monto } = rango[i];

                // Calcular el número de horas dentro de este tramo
                const tramoHoras = maximo - minimo;

                const horasEnEsteTramo = Math.min(tramoHoras, horasRestantes);

                if (horasEnEsteTramo > 0) {
                    totalIncentivo += horasEnEsteTramo * monto;
                    horasRestantes -= horasEnEsteTramo;
                }

                if (horasRestantes <= 0) break;
            }
            bono = 0

            // ✅ Sumar bono solo si horasTotales > 150
            if (horasTotales > 150) {
                bono = 700
                // totalIncentivo += bono;
            }

            setIncentivo((prev) => ({
                ...prev,
                bono: bono,
                incentivo: totalIncentivo.toFixed(2),
                incentivoTotal: (totalIncentivo + bono).toFixed(2)
            }));
        }
    }, [incentivo.horas, incentivo.nivel]);

    return (
        <>
            <div className="simulador-incentivo-sin-incentivo-total">
                <FormControl fullWidth size="small" sx={{ mb: 2, background: '#dae6be' }}>
                    <InputLabel id="sucursal-label">Nivel</InputLabel>
                    <Select
                        labelId="sucursal-label"
                        name="nivel"
                        value={incentivo.nivel}
                        label="nivel"
                        onChange={handleChange}
                    >
                        <MenuItem value="M">Master</MenuItem>
                        <MenuItem value="A">Avanzado</MenuItem>
                        <MenuItem value="S">Servicio</MenuItem>
                    </Select>
                </FormControl>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon /> Horas en Taller
                    </div>

                    <div className="simulador-incentivo-vendedor-f3">
                        <div className="input-section-container-numeric">
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Horas Trabajadas del mes (#)</div>
                                    <SimuladorNumericInput
                                        name="horas"
                                        // label=""
                                        value={incentivo.horas}
                                        disabled={false}
                                        onChange={handleChange}
                                        icono="numero"
                                    />
                                </div>
                            </div>
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Pago por destajo:</div>
                                    <SimuladorNumericInput
                                        name="incentivo"
                                        // label=""
                                        value={incentivo.incentivo}
                                        disabled={true}
                                        icono="pesos"
                                        inputTotal="si"
                                    />
                                </div>
                            </div>
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Bono adicional:</div>
                                    <SimuladorNumericInput
                                        name="incentivo"
                                        // label=""
                                        value={incentivo.bono}
                                        disabled={true}
                                        icono="pesos"
                                        inputTotal="si"
                                    />
                                </div>
                            </div>
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Tu incentivo es de:</div>
                                    <SimuladorNumericInput
                                        name="incentivo"
                                        // label=""
                                        value={incentivo.bono > 0 ? incentivo.incentivoTotal : incentivo.incentivo}
                                        disabled={true}
                                        icono="pesos"
                                        inputTotal="si"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosTecnicoServicio;
